/**
 * Central API configuration.
 *
 * Every backend URL used by the dashboard is built from here, so switching
 * environments means editing REACT_APP_API_BASE_URL in `.env` only. Do not
 * hardcode a host or a port anywhere else in `src/`.
 *
 * Create React App inlines REACT_APP_* variables at build time, so the dev
 * server has to be restarted after `.env` changes.
 */

const FALLBACK_BASE_URL = "https://cex-minikube-dev-api.quecko.org";

// Trailing slashes would produce "//markets" once a path is appended.
const stripTrailingSlash = (value) => String(value).replace(/\/+$/, "");

/** Root of the API gateway, e.g. https://cex-minikube-dev-api.quecko.org */
export const API_BASE_URL = stripTrailingSlash(
  process.env.REACT_APP_API_BASE_URL || FALLBACK_BASE_URL
);

/**
 * Auth service: login, OTP verification, sessions.
 * Replaces the old `http://<ip>:9080/api/v1` base.
 */
export const AUTH_API_URL = `${API_BASE_URL}/auth/api/v1`;

/**
 * Assets service: chains, markets, networks, pairs, tokens.
 * Replaces the old `http://<ip>:9085` base.
 */
export const ASSETS_API_URL = `${API_BASE_URL}/assets`;

const apiConfig = { API_BASE_URL, AUTH_API_URL, ASSETS_API_URL };

export default apiConfig;
